"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newQuizPin = void 0;
const lodash_1 = require("lodash");
const tip_tap_1 = require("../../tip-tap");
const newQuizPin = (layout, correctAnswers = [], answers = [
    { type: 'TEXT', text: 'Answer A', id: 'A' },
    { type: 'TEXT', text: 'Answer B', id: 'B' },
    { type: 'TEXT', text: 'Answer C', id: 'C' },
    { type: 'TEXT', text: 'Answer D', id: 'D' },
]) => {
    const basePin = {
        type: 'MULTIPLE_CHOICE',
        settings: {
            layout: layout.key,
            backgroundColor: layout.backgroundColor,
            backgroundImage: layout.backgroundImage,
            answers: transformQuizPinAnswers(answers),
            layoutParts: (0, lodash_1.mapValues)(layout.layoutParts, (comp) => comp?.id),
            questionId: layout.layoutParts.TITLE?.id,
        },
        teacherSettings: {
            correctAnswers: correctAnswers || [],
        },
        pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
    };
    if ('backgroundTransparency' in layout && layout.backgroundTransparency !== undefined) {
        basePin.settings.backgroundTransparency = layout.backgroundTransparency;
    }
    return basePin;
};
exports.newQuizPin = newQuizPin;
function transformQuizPinAnswers(answers) {
    return answers.map((answer) => {
        if (answer.type === 'TEXT') {
            return { ...answer, text: (0, tip_tap_1.stringToLeanProsemirror)(answer.text) };
        }
        return answer;
    });
}
//# sourceMappingURL=quiz-pin.js.map